import cn from 'classnames';
import {
  Form as FormikForm,
  Formik,
  FormikActions,
  FormikProps,
  FormikValues
} from 'formik';
import React from 'react';
import './Forms.css';

interface Props {
  children: (props: FormikProps<FormValues>) => React.ReactNode;
  initialValues: FormValues;
  type?: FormTypes;
  isInitialValid?: boolean;
  enableReinitialize?: boolean;
  validationSchema?: any | (() => any);
  validate?: (values: FormValues) => any;
  onSubmit?: (values: FormValues, actions: FormActions) => void;
  autoComplete?: 'on' | 'off';
  hideReqMsg?: boolean;
  reqMsg?: string;
}

type FormActions = FormikActions<FormikValues>;
type FormValues = FormikValues;
type FormTypes = 'horizontal' | 'vertical' | 'compact';

const noop = () => Object.create(null);

const Form: React.FC<Props> = props => {
  const {
    autoComplete,
    children,
    type,
    initialValues,
    onSubmit,
    validationSchema,
    validate,
    enableReinitialize,
    isInitialValid,
    hideReqMsg,
    reqMsg
  } = props;

  const classNames = cn('clr-form', 'crc-form', {
    [`clr-form-${type}`]: type
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit || noop}
      enableReinitialize={enableReinitialize}
      isInitialValid={isInitialValid}
      validationSchema={validationSchema}
      validate={validate}>
      {formProps => (
        <FormikForm autoComplete={autoComplete} className={classNames}>
          {!hideReqMsg &&
            (reqMsg ? (
              <p
                className="clr-form-required-text"
                dangerouslySetInnerHTML={{ __html: reqMsg }}></p>
            ) : (
              <p className="clr-form-required-text">
                Required fields are marked with <span>*</span>
              </p>
            ))}
          {children(formProps)}
        </FormikForm>
      )}
    </Formik>
  );
};

export default Form;
